module.exports = __webpack_public_path__ + "static/media/quiz6.d5d60d5d.png";